<template>
  <div class="full_page c-p-t-20">
    <!-- <div class="top c-p-20">
      <div>待使用</div>
      <div class="">
        <span>实付款:</span>
        <span><i class="c-yang">￥</i>{{money}}</span>
      </div>
    </div>
    <g-img-list>
      <div class="r-box">
        <div class="c-fl-bt">
          <div class="r-top">
            <span> 标准间</span>
          </div>
          <div class="r-top">x3</div>
        </div>
        <div class="sub-txt">
          {{subTxt}}
        </div>
        <div class="c-fl r-bottom">
          <div class="main-money">
            <span class="c-yang">￥</span>
            <span>{{mainMoney}}</span>
          </div>
          <div class="c-del-txt">
            <span class="c-yang">￥</span>
            <span class="c-yang">{{originMoney}}</span>
          </div>
        </div>
      </div>
    </g-img-list>
    <g-line></g-line>
    <van-cell-group>
      <div
        v-for="(v, i) in orderList"
        :key="i"
      >
        <van-cell
          :title="v.orderName"
          :value="v.val"
        />
      </div>
    </van-cell-group> -->
    <!-- <gTitle :t="aData.Status.Name"></gTitle> -->
    <div class="f-bt status_title_con">
      <div>{{ aData.Status.Name }}</div>
      <div v-if="aData.Status.Id == 1">
        <span>实付款:</span>
        <span><i class="c-yang">￥</i>{{ aData.allSettlePrice }}</span>
      </div>
    </div>

    <div v-if="aDetails">
      <div class="c-p-20" v-for="(v, i) in aDetails" :key="i">
        <!-- <div class="top">{{v.Status.Name}}</div> -->

        <template>
          <g-img-list :src="v.ProductImageUrl">
            <div class="r-box">
              <div class="c-fl-bt">
                <div class="r-top">
                  <span>{{ v.ProductName }}</span>
                </div>
                <div class="r-top">x{{ v.Quantity }}</div>
              </div>
              <div class="sub-txt"></div>
              <div class="c-fl r-bottom">
                <div class="main-money">
                  <span class="c-yang">￥</span>
                  <span>{{ v.Price }}</span>
                </div>
                <div class="c-del-txt">
                  <span class="c-yang">￥</span>
                  <span class="c-yang">{{ v.SettlePrice }}</span>
                </div>
              </div>
            </div>
          </g-img-list>
        </template>

        <g-line></g-line>
      </div>
    </div>
    <van-cell-group>
      <van-cell title="订单编号" :value="aData.Id"></van-cell>
      <van-cell title="下单时间" :value="aData.CreateTime"></van-cell>
      <van-cell
        v-if="aData.PayTime"
        title="支付时间"
        :value="aData.PayTime"
      ></van-cell>
    </van-cell-group>

    <!-- <div v-if="aData.Status">
      <van-cell-group v-if="drawItem.length > 0">
        <div v-for="(val, idx) in drawItem" :key="idx">
          <van-cell
            @click="toApplyDetail(val.Id)"
            isLink
            :title="val.CreateTime"
            :value="val.Status.Name"
          ></van-cell>
        </div>
      </van-cell-group>
    </div> -->

    <gBottomBtnGroup v-if="aData.Status.Id == 1">
      <div
        class="c-theme c-bg-theme-opacity c-f-1 c-block c-f-ar"
        @click="applyDrawback"
      >
        申请退单
      </div>
      <div
        class="c-f-1 c-block c-bg-theme c-f-ar c-white"
        v-if="aData.Status.Id === 1"
        @click="lookCode"
      >
        查看消费码
      </div>
    </gBottomBtnGroup>
    <!-- 待付款 -->
    <gBottomBtnGroup v-if="aData.Status.Id == 0">
      <div
        class="c-theme c-bg-theme c-f-1 c-block c-f-ar c-white"
        @click="handleToPay"
      >
        继续支付
      </div>
    </gBottomBtnGroup>
  </div>
</template>

<script>
/**
 * id: 订单状态
 * 0: 待付款
 * 1: 待使用
 * 2: 已取消
 * 3: 退款中
 * 4: 已退款
 * 5: 已完成
 */
import { getOrderDetail } from "@/api/order";
export default {
  name: "OrderDetail",
  props: {},
  data() {
    return {
      orderId: this.$route.query.id,
      aData: { Status: {} },
      aDetails: {},
      money: 123.0,
      subTxt: "17-22㎡、不含早餐、 有窗",
      mainMoney: "88.76",
      originMoney: "338.00",
      drawItem: [],
    };
  },
  created() {
    this.init();
    // this.getDrawList();
  },
  mounted() {},
  methods: {
    lookCode() {
      this.$router.push({
        name: "ConsumeCode",
        params: { id: this.aData.Id },
      });
    },
    toApplyDetail(id) {
      this.$router.push({
        name: "DrawbackDetail",
        params: {
          id,
        },
      });
    },
    handleToPay() {
      this.$router.push({
        name: "PayList",
        query: {
          id: this.aData.Id,
          fromPage:
            this.aData.EventType && this.aData.EventType.Id == 3
              ? "flash"
              : "goodsmall",
        },
      });
    },
    // 获取退单列表
    // getDrawList() {
    //   return new Promise((r, j) => {
    //     $http(`wechath5/zh-cn/v1/refund?query.OrderId=${this.orderId}`).then(
    //       (res) => {
    //         console.log(
    //           "%c res ",
    //           "background-image:color:transparent;color:blue;font-size:2em"
    //         );
    //         console.log(res);
    //         this.drawItem = res.Items;
    //         r(res.Items);
    //       }
    //     );
    //   });
    // },
    translateOrderStatus(val, name) {
      if (val === 3) {
        return "退款中";
      } else if (val === 4) {
        return "已到账";
      }
    },
    applyDrawback() {
      this.$router.push({
        path: "/goods/applyDrawback",
      });
    },
    async init() {
      const resDatas = await getOrderDetail({ query: { id: this.orderId } });
      if (resDatas && resDatas.Items.length > 0) {
        let orderData = resDatas.Items[0];
        let SettlePrice = 0;
        orderData.Details.forEach((v) => {
          SettlePrice += v.Quantity * v.Price;
        });
        orderData.allSettlePrice = SettlePrice;
        this.aData = orderData;
        this.aDetails = resDatas.Items[0].Details;
        this.$store.commit("setStoreVal", { orderDetails: this.aDetails });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.status_title_con {
  padding: 20px 30px;
  background: var(--tc);
  color: #fff;
}
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #00cccc;
  div,
  span {
    color: var(--tc);
    opacity: 1;
  }
}
.r-box {
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: space-between;
  height: 100%;
  .r-top {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .sub-txt {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    position: relative;
    top: -20px;
    color: #888888;
    margin-top: 10px;
  }
  .r-bottom {
    align-items: baseline;
    .main-money {
      margin-right: 10px;
      font-size: 32px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #f83d3d;
    }
  }
}
</style>
